import React from 'react';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
import Form from './Form';
import FormGroup from '../../atoms/FormGroup';
import FormItem from '../../atoms/FormItem';
import ErrorGraphQL from '../../../errors/ErrorGraphQL';

import Loading from '../../molecules/Loading';
import createMutationHandler from '../../shared/create-mutationhandler';

const CREATE_MUTATION = gql`
  mutation Create($data: BankAccountCreateInput) {
    createBankAccount(data: $data) {
      __typename
      ... on BankAccount {
        id
      }
      ... on InvalidData {
        message
        errors {
          property
          message
        }
      }
      ... on Unauthorized {
        message
      }
      ... on AlreadyExists {
        message
        errors {
          property
          message
        }
      }
    }
  }
`;

const Create = ({ match, history }) => {
  const [createMutation, { error: createError, loading: createLoading }] = useMutation(CREATE_MUTATION);

  // CREATE-MUTATION
  const handleCreateMutation = (mutation) => {
    const handledCreateMutation = createMutationHandler({
      mutation,
      mutationName: 'createBankAccount',
      mutationReturnTypes: {
        BankAccount: {
          successMessage: (data) => `Bankkonto mit der ID ${data.id} erfolgreich erstellt`,
          onSuccess: () => history.push('/bankaccounts'),
        },
      },
      serverErrorMessage: `Erstellung des Bankkontos nicht erfolgreich`,
    });

    return (values) =>
      handledCreateMutation({
        variables: {
          data: values,
        },
      });
  };

  if (createLoading) {
    return <Loading />;
  }

  return (
    <fieldset disabled={createLoading}>
      <FormGroup>
        <FormItem>
          <h2 name="form-headline">Neues Bankkonto erstellen</h2>
        </FormItem>
      </FormGroup>

      <ErrorGraphQL error={createError} />
      <Form data={{}} submitButtonText="Neues Bankkonto erstellen" mutation={handleCreateMutation(createMutation)} />
    </fieldset>
  );
};

export default Create;
